












import { Component, Inject, Vue } from 'vue-property-decorator';

import Sidebar from '@/@core/components/sidebar/Sidebar.vue';
import Breadcrumb from '@/@core/components/breadcrumb/Breadcrumb.vue';
import menu from '@/router/menu';
import { AuthService } from '@/data/services/auth.service';
import jwtDecode from 'jwt-decode';
import store, { State } from '@/store';
import { UserType } from '@/data/models/user.model';

@Component({
	components: {
		Sidebar,
		Breadcrumb,
	},
})
export default class Main extends Vue {
	@Inject('AuthService') authService!: AuthService;

	timer: any | null = null;

	state!: State;

	constructor() {
		super();
		this.state = store;
	}

	get menu() {
		return menu;
	}

	scheduleRenew() {
		this.authService.renew().then(() => {
			const token = jwtDecode(this.authService.getToken());
			const d = new Date(token.exp * 1000);
			d.setHours(d.getHours() - 1);
			// disable renew when exp is not valid
			const now = new Date();
			if (d <= now) return;
			const timeout = Math.min(d.getTime() - now.getTime(), 86400 * 1000);
			this.timer = setTimeout(() => this.scheduleRenew(), timeout);
		});
	}

	created() {
		this.scheduleRenew();
		if (this.state.user!.utype === UserType.CALL_CENTER) {
			if (this.$route.path === '/') {
				this.$router.replace('/callcenter');
			}
		}
	}
}
